import { IMG, Icon } from "../lib/shared"
import { useSettings } from "../lib/content"
/* The light logo is a real asset. Inverting the dark one turns the cyan cube
   orange, which is what this page used to do. */
import logoLightUrl from "@/assets/sableboxx-logo-light.png"

/* Stamped in at build time by vite.config.ts; see shared.tsx. */
declare const __BUILD_YEAR__: string

export default function Maintenance() {
  const { settings } = useSettings()

  return (
    <main className="relative isolate flex min-h-screen flex-col justify-center overflow-hidden lg:items-center bg-ink px-6 text-white">
      {/* backdrop */}
      <div className="absolute inset-0 -z-10">
        <img
          src={IMG.heroAbstract}
          alt=""
          className="h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/85 to-ink" />
      </div>

      <div className="w-full max-w-xl lg:text-center">
        <img
          src={logoLightUrl}
          alt="Sableboxx"
          className="h-8 w-auto lg:mx-auto"
        />

        <span className="mt-12 inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.24em] text-white/70">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-bright opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-bright" />
          </span>
          Under maintenance
        </span>

        <h1 className="mt-8 text-[clamp(2.2rem,5vw,3.4rem)] font-black leading-[1.05] tracking-[-0.035em]">
          {settings.maintenanceTitle}
        </h1>

        <p className="mt-6 max-w-md lg:mx-auto text-[16px] leading-[1.7] text-neutral-300">
          {settings.maintenanceMessage}
        </p>

        {settings.maintenanceEta && (
          <p className="mt-8 inline-flex items-center gap-2.5 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-[14px] font-medium text-white">
            <Icon name="clarity" className="h-4 w-4 text-accent-bright" />
            {settings.maintenanceEta}
          </p>
        )}

        <div className="mt-12 flex flex-col items-start gap-4 lg:items-center">
          <p className="text-[13px] text-neutral-400">
            Need to reach us in the meantime?
          </p>
          <a
            href="mailto:hello@sableboxx.com"
            className="group inline-flex items-center gap-2.5 rounded-full bg-white px-5 py-3 text-[13px] font-medium text-ink transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.25)]"
          >
            <Icon name="mail" className="h-4 w-4" />
            hello@sableboxx.com
          </a>
        </div>
      </div>

      <p className="absolute bottom-8 left-6 pr-6 text-[12px] text-neutral-500 lg:left-auto lg:pr-0">
        &copy; {__BUILD_YEAR__} Sableboxx · Software &amp; Digital Infrastructure
      </p>
    </main>
  )
}
